import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { PageLoader } from '../components/PageLoader'

const InvitationPage = lazy(() => import('../pages/InvitationPage'))
const StoriesPage = lazy(() => import('../pages/StoriesPage'))
const StoryPage = lazy(() => import('../pages/StoryPage'))
const AdminApp = lazy(() => import('../admin/AdminApp'))

export function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<InvitationPage />} />
        <Route path="/stories" element={<StoriesPage />} />
        <Route path="/stories/:slug" element={<StoryPage />} />
        <Route path="/admin/*" element={<AdminApp />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  )
}
